export default __webpack_public_path__ + "static/media/TF_01.d780ebf9.png";